import React from 'react';

const MapFilterPanels = ({
  categories, selectedCategories, toggleCategory, setSelectedCategories,
  categoryColorMap, mapResults, filteredMapResults,
  showCategoryFilter, setShowCategoryFilter,
  educatedIndividualFilters, setEducatedIndividualFilters,
  selectedDocTypes, setSelectedDocTypes, documentTypes,
  certificationFilters, setCertificationFilters
}) => {
  return (
    <>
      {/* Category Filter Section */}
      <div style={{ 
        background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(245, 158, 11, 0.1))',
        borderRadius: 12,
        padding: 15,
        marginBottom: 15,
        border: '1px solid rgba(16, 185, 129, 0.3)'
      }} data-testid="category-filter-section">
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          marginBottom: showCategoryFilter ? 12 : 0
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <h4 style={{ color: '#10b981', margin: 0, fontSize: '0.95rem' }}>
              Filter by Category
            </h4>
            {selectedCategories.length > 0 && (
              <span style={{
                background: 'linear-gradient(135deg, #10b981, #3b82f6)',
                padding: '2px 10px',
                borderRadius: 20,
                fontSize: '0.75rem',
                color: '#0F172A',
                fontWeight: 600
              }}>
                {selectedCategories.length} selected &bull; {filteredMapResults.length} results
              </span>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {selectedCategories.length > 0 && (
              <button
                onClick={() => setSelectedCategories([])}
                style={{
                  background: 'rgba(239, 68, 68, 0.2)',
                  border: '1px solid rgba(239, 68, 68, 0.3)',
                  color: '#f87171',
                  padding: '4px 10px',
                  borderRadius: 6,
                  fontSize: '0.75rem',
                  cursor: 'pointer'
                }}
                data-testid="clear-category-filter"
              >
                Clear All
              </button>
            )}
            <button
              onClick={() => setShowCategoryFilter(!showCategoryFilter)}
              style={{
                background: showCategoryFilter ? 'rgba(16, 185, 129, 0.2)' : 'transparent',
                border: '1px solid rgba(16, 185, 129, 0.3)',
                color: '#10b981',
                padding: '4px 10px',
                borderRadius: 6,
                fontSize: '0.75rem',
                cursor: 'pointer'
              }}
            >
              {showCategoryFilter ? '\u25B2 Collapse' : '\u25BC Expand'}
            </button>
          </div>
        </div>
        
        {showCategoryFilter && categories.length > 0 && (
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 8
          }}>
            {categories.map((category) => {
              const catId = category.id || category._id;
              const isSelected = selectedCategories.includes(catId);
              const color = categoryColorMap[category.name] || '#6b7280';
              const categoryResults = mapResults.filter(r => 
                r.categories && r.categories.includes(category.name)
              );
              
              return (
                <label
                  key={catId}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    padding: '6px 12px',
                    background: isSelected ? `${color}25` : '#475569',
                    border: `2px solid ${isSelected ? color : 'transparent'}`,
                    borderRadius: 20,
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    fontSize: '0.8rem'
                  }}
                  data-testid={`category-filter-${category.name}`}
                >
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => toggleCategory(catId)}
                    style={{ display: 'none' }}
                  />
                  <div style={{
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    background: color,
                    boxShadow: isSelected ? `0 0 8px ${color}` : 'none'
                  }} />
                  <span style={{ color: isSelected ? '#fff' : '#a1a1aa' }}>
                    {category.name}
                  </span>
                  <span style={{
                    background: 'rgba(0,0,0,0.3)',
                    padding: '1px 6px',
                    borderRadius: 10,
                    fontSize: '0.65rem',
                    color: '#71717a'
                  }}>
                    {categoryResults.length}
                  </span>
                </label>
              );
            })}
          </div>
        )}
        
        {showCategoryFilter && categories.length === 0 && (
          <p style={{ color: '#71717a', fontSize: '0.8rem', margin: 0 }}>
            No categories yet. Create categories in Ultimate Search to filter results here.
          </p>
        )}
      </div>

      {/* Educated Individual Sites - Educational Content from Experts */}
      <div style={{
        marginBottom: 15,
        padding: 15,
        background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.1), rgba(239, 68, 68, 0.1))',
        borderRadius: 12,
        border: '1px solid rgba(245, 158, 11, 0.3)'
      }} data-testid="educated-individual-filter-map">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h4 style={{ color: '#f59e0b', margin: 0, fontSize: '0.95rem' }}>
            Educated Individual Sites
            <span style={{ fontSize: '0.7rem', color: '#a1a1aa', fontWeight: 'normal', marginLeft: 8 }}>
              Single-URL educational content from self-taught experts
            </span>
          </h4>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={() => setEducatedIndividualFilters({
                science: true, engineering: true, construction: true,
                culinary: true, trades: true, mathematics: true, technology: true
              })}
              style={{
                background: 'rgba(16, 185, 129, 0.2)',
                border: '1px solid rgba(16, 185, 129, 0.3)',
                color: '#10b981',
                padding: '4px 10px',
                borderRadius: 6,
                fontSize: '0.7rem',
                cursor: 'pointer'
              }}
              data-testid="educated-individual-all-map"
            >
              All Topics
            </button>
            <button
              onClick={() => setEducatedIndividualFilters({
                science: false, engineering: false, construction: false,
                culinary: false, trades: false, mathematics: false, technology: false
              })}
              style={{
                background: 'rgba(239, 68, 68, 0.2)',
                border: '1px solid rgba(239, 68, 68, 0.3)',
                color: '#f87171',
                padding: '4px 10px',
                borderRadius: 6,
                fontSize: '0.7rem',
                cursor: 'pointer'
              }}
              data-testid="educated-individual-clear-map"
            >
              Clear
            </button>
          </div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {[
            { id: 'science', label: 'Science', desc: 'Chemistry, Physics, Biology' },
            { id: 'engineering', label: 'Engineering', desc: 'Electrical, Mechanical, Civil' },
            { id: 'construction', label: 'Construction', desc: 'Framing, Plumbing, HVAC' },
            { id: 'culinary', label: 'Culinary', desc: 'Cooking, Recipes, Methods' },
            { id: 'trades', label: 'Trades', desc: 'Welding, Carpentry, Masonry' },
            { id: 'mathematics', label: 'Mathematics', desc: 'Calculus, Algebra, Geometry' },
            { id: 'technology', label: 'Technology', desc: 'Programming, Hardware, IT' }
          ].map(topic => (
            <label
              key={topic.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                padding: '8px 12px',
                background: educatedIndividualFilters[topic.id]
                  ? 'rgba(245, 158, 11, 0.2)'
                  : '#475569',
                border: educatedIndividualFilters[topic.id]
                  ? '2px solid #f59e0b'
                  : '1px solid rgba(255,255,255,0.1)',
                borderRadius: 8,
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              title={topic.desc}
              data-testid={`educated-individual-${topic.id}-map`}
            >
              <input
                type="checkbox"
                checked={educatedIndividualFilters[topic.id]}
                onChange={() => setEducatedIndividualFilters(prev => ({
                  ...prev,
                  [topic.id]: !prev[topic.id]
                }))}
                style={{ accentColor: '#f59e0b' }}
              />
              <span style={{ 
                color: educatedIndividualFilters[topic.id] ? '#f59e0b' : '#e2e8f0',
                fontSize: '0.8rem',
                fontWeight: educatedIndividualFilters[topic.id] ? 600 : 400
              }}>
                {topic.label}
              </span>
            </label>
          ))}
        </div>
        <p style={{ color: '#71717a', fontSize: '0.75rem', marginTop: 10, marginBottom: 0 }}>
          Find expert knowledge from self-educated individuals sharing academic and trade expertise via comprehensive single-URL sites.
        </p>
      </div>

      {/* Document Type Filter */}
      <div style={{
        marginBottom: 15, padding: 15,
        background: 'rgba(255, 255, 255, 0.4)', borderRadius: 12,
        border: '1px solid rgba(252, 211, 77, 0.2)'
      }} data-testid="document-type-filter-map">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <h4 style={{ color: '#047857', margin: 0, fontSize: '0.95rem' }}>
            Filter by Document Type
            {selectedDocTypes.length < documentTypes.length && (
              <span style={{ fontSize: '0.7rem', color: '#f59e0b', marginLeft: 8 }}>
                ({selectedDocTypes.length}/{documentTypes.length} selected)
              </span>
            )}
          </h4>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => setSelectedDocTypes(documentTypes.map(dt => dt.id))}
              style={{ background: 'rgba(16,185,129,0.2)', border: '1px solid rgba(16,185,129,0.3)', color: '#10b981', padding: '4px 10px', borderRadius: 6, fontSize: '0.7rem', cursor: 'pointer' }}
              data-testid="map-select-all-doctypes">All</button>
            <button onClick={() => setSelectedDocTypes([])}
              style={{ background: 'rgba(239,68,68,0.2)', border: '1px solid rgba(239,68,68,0.3)', color: '#f87171', padding: '4px 10px', borderRadius: 6, fontSize: '0.7rem', cursor: 'pointer' }}
              data-testid="map-clear-all-doctypes">Clear</button>
          </div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {documentTypes.map(dt => {
            const isSelected = selectedDocTypes.includes(dt.id);
            return (
              <label key={dt.id} style={{
                display: 'flex', alignItems: 'center', gap: 5, padding: '5px 10px', borderRadius: 8, cursor: 'pointer',
                background: isSelected ? `${dt.color}25` : '#475569',
                border: isSelected ? `2px solid ${dt.color}` : '1px solid rgba(255,255,255,0.1)',
                transition: 'all 0.2s', fontSize: '0.75rem'
              }} data-testid={`map-doctype-${dt.id.replace(/[^a-z0-9]/gi, '-').toLowerCase()}`}>
                <input type="checkbox" checked={isSelected}
                  onChange={() => setSelectedDocTypes(prev => prev.includes(dt.id) ? prev.filter(d => d !== dt.id) : [...prev, dt.id])}
                  style={{ accentColor: dt.color, width: 12, height: 12 }} />
                <span style={{ color: isSelected ? dt.color : '#a1a1aa', fontWeight: isSelected ? 600 : 400 }}>{dt.name}</span>
              </label>
            );
          })}
        </div>
      </div>

      {/* Certification Filters */}
      <div style={{
        marginBottom: 15, padding: 15,
        background: 'rgba(253, 224, 71, 0.05)', borderRadius: 12,
        border: '1px solid rgba(253, 224, 71, 0.15)'
      }} data-testid="certification-filter-map">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <h4 style={{ color: '#047857', margin: 0, fontSize: '0.95rem' }}>
            Certification Filters
            <span style={{ fontSize: '0.7rem', color: '#71717a', marginLeft: 8 }}>
              ({Object.values(certificationFilters).filter(v => v).length}/3 active)
            </span>
          </h4>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => setCertificationFilters({ pearsonvue: true, government: true, advancedDegree: true })}
              style={{ background: 'rgba(16,185,129,0.2)', border: '1px solid rgba(16,185,129,0.3)', color: '#10b981', padding: '4px 10px', borderRadius: 6, fontSize: '0.7rem', cursor: 'pointer' }}
              data-testid="map-select-all-certs">All</button>
            <button onClick={() => setCertificationFilters({ pearsonvue: false, government: false, advancedDegree: false })}
              style={{ background: 'rgba(239,68,68,0.2)', border: '1px solid rgba(239,68,68,0.3)', color: '#f87171', padding: '4px 10px', borderRadius: 6, fontSize: '0.7rem', cursor: 'pointer' }}
              data-testid="map-clear-all-certs">Clear</button>
          </div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {[
            { key: 'pearsonvue', label: 'PearsonVUE', color: '#FDE047' },
            { key: 'government', label: 'Government', color: '#ef4444' },
            { key: 'advancedDegree', label: 'Advanced Degree', color: '#3b82f6' }
          ].map(f => (
            <label key={f.key} style={{
              display: 'flex', alignItems: 'center', gap: 6, padding: '8px 12px', borderRadius: 8, cursor: 'pointer',
              background: certificationFilters[f.key] ? `${f.color}20` : '#475569',
              border: certificationFilters[f.key] ? `2px solid ${f.color}` : '1px solid rgba(255,255,255,0.1)',
              transition: 'all 0.2s'
            }} data-testid={`map-cert-${f.key}`}>
              <input type="checkbox" checked={certificationFilters[f.key]}
                onChange={() => setCertificationFilters(prev => ({ ...prev, [f.key]: !prev[f.key] }))}
                style={{ accentColor: f.color }} />
              <span style={{ color: certificationFilters[f.key] ? '#fff' : '#a1a1aa', fontSize: '0.8rem', fontWeight: certificationFilters[f.key] ? 600 : 400 }}>{f.label}</span>
            </label>
          ))}
        </div>
      </div>
    </>
  );
};

export default MapFilterPanels;
